// import { UserContextService } from './../../core/services/user-context.service';
import { Component, OnInit, AfterViewInit, ViewChild, Input } from '@angular/core';
// import { ToastService } from '../../core/services/toast.service';
// import { LoaderService } from '../../core/services/loader.service';
import { MenuDataService } from '../../core/services/menu-data.service';
import { CustomMenuItem } from '../../core/models/menu-item.model';
import { Sidebar } from 'primeng/sidebar';
import { ApplicationStateService } from '../../core/services/application-state.service';
// import { RouteStateService } from '../../core/services/route-state.service';
// import { CommonService } from 'src/app/core/services/common.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements AfterViewInit, OnInit {

  groupID: string;
  // Menu
  itemsSetup: CustomMenuItem[];
  itemsEmployeeInformation: CustomMenuItem[];
  itemsTimeKeeping: CustomMenuItem[];
  itemsSalaryCalculation: CustomMenuItem[];
  itemsInsurancesAndOther: CustomMenuItem[];

  isMenuVisible: boolean;

  showSetup: boolean = true;
  showEmployeeInformation: boolean = true;
  showTimeKeeping: boolean = true;
  showSalaryCalculation: boolean = true;
  showInsurancesAndOther: boolean = true;
  
  isMobileResolution: boolean = false;

  @ViewChild("menubar", { static: true }) menubar: Sidebar;

  constructor(
    // private toastService: ToastService,
    // private loaderService: LoaderService,
    private menuDataService: MenuDataService,
    // private routeStateService: RouteStateService,
    // private userContextService: UserContextService,
    private applicationStateService: ApplicationStateService,
    private localStorageService: LocalStorageService,
  ) {
  }

  ngOnInit() {

    // let accessModules : string = this.localStorageService.getItem("AccessModule");
    // let access : string[] = accessModules.split(',');
    // access.forEach(element =>{
    //   if(element == "Setup"){
    //     this.showSetup = true;
    //   }
    //   else if(element == "EmployeeInformation"){
    //     this.showEmployeeInformation = true;
    //   }
    //   else if(element == "TimeKeeping"){
    //     this.showTimeKeeping = true;
    //   }
    //   else if(element == "SalaryCalculatio"){
    //     this.showSalaryCalculation = true;
    //   }
    //   else if(element == "InsurancesAndOther"){
    //     this.showInsurancesAndOther = true;
    //   }
    // })
    
    // this.loaderService.show();
    // Menu
    this.itemsSetup = this.menuDataService.getMenuSetup(this.localStorageService.getItem("AccessFoSetup"));
    this.itemsEmployeeInformation = this.menuDataService.getMenuEmployeeInformation(this.localStorageService.getItem("AccessFoEmployeeInformation"));
    this.itemsTimeKeeping = this.menuDataService.getMenuTimeKeeping(this.localStorageService.getItem("AccessFoTimeKeeping"));
    this.itemsSalaryCalculation = this.menuDataService.getMenuSalaryCalculation(this.localStorageService.getItem("AccessFoSalaryCalculation"));
    this.itemsInsurancesAndOther = this.menuDataService.getMenuInsurancesAndOther(this.localStorageService.getItem("AccessFoInsurancesAndOther"));

    // let a: CustomMenuItem[] = [];
    // a.push.apply(a, this.itemsSetup);
    // a.push.apply(a, this.itemsEmployeeInformation);
    // a.push.apply(a, this.itemsTimeKeeping);
    // a.push.apply(a, this.itemsSalaryCalculation);
    // a.push.apply(a, this.itemsInsurancesAndOther);
    // // import("xlsx").then(xlsx => {
    // //   let worksheet;
    // //   worksheet = xlsx.utils.json_to_sheet(a);
    // //   const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    // //   const excelBuffer: any = xlsx.write(workbook, { bookType: 'csv', type: 'array' });
    // //   import("file-saver").then(FileSaver => {
    // //     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    // //     let EXCEL_EXTENSION = '.csv';
    // //     const data: Blob = new Blob([excelBuffer], {
    // //       type: EXCEL_TYPE
    // //     });
    // //     FileSaver.saveAs(data, "NameForm" + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    // //   });
    // // });

    // let b = [];
    // a.forEach(element => {
    //   let c: { Label: string, RouterLink: string, DescrVN: string, DescrEN: string } = { Label: '', RouterLink: "", DescrVN: "", DescrEN: "" } ;
    //   c.Label = element.Label;
    //   c.RouterLink = element.RouterLink;
    //   c.DescrVN = this.getMessage(element.Label);
    //   c.DescrEN = this.getMessage(element.Label);
    //   b.push(c);
    // });

    // import("xlsx").then(xlsx => {
    //   let worksheet;
    //   worksheet = xlsx.utils.json_to_sheet(b);
    //   const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //   const excelBuffer: any = xlsx.write(workbook, { bookType: 'csv', type: 'array' });
    //   import("file-saver").then(FileSaver => {
    //     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     let EXCEL_EXTENSION = '.csv';
    //     const data: Blob = new Blob([excelBuffer], {
    //       type: EXCEL_TYPE
    //     });
    //     FileSaver.saveAs(data, "Descr" + '_export_' + EXCEL_EXTENSION);
    //   });
    // });

    this.isMobileResolution = this.applicationStateService.getIsMobileResolution();
    if (this.isMobileResolution) {
      this.isMenuVisible = true;
    }
    else {
      this.isMenuVisible = true;
    }
  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.loaderService.hide();
    // }, 1000);
  }

  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible
  }

}
